import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Alert, Button, Checkbox, Label, LabeledControl, Spacer, Text, TextButton } from '@zillow/constellation-10';
import { HR } from '@zg-rentals/zrs-comet';
import { logError, useRentalManagerUser, UserPermissionsConstants } from '@zg-rentals/rental-manager-env';
import UserManagementActions from '../../redux/actions/UserManagementActions';
import { emitContinueNewUserRoleEvent, EVENT_IDS } from '../../modal/ClickstreamEvents';

const { COMPANY_ADMIN, COMPANY_USER } = UserPermissionsConstants.PERMISSIONS;

export interface RoleTypes {
  onNextStep: () => void;
  onCancel: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUser?: any;
  onBack: () => void;
  handleSaveComplete: () => void;
}

const Role = ({ onNextStep, onCancel, currentUser, onBack, handleSaveComplete }: RoleTypes) => {
  const dispatch = useDispatch();
  const { user } = useRentalManagerUser();
  const { isInvitation } = currentUser;
  const isAdmin = currentUser.permissions[COMPANY_ADMIN];
  const isUser = !isAdmin && currentUser.permissions[COMPANY_USER];
  const isUserTypeSet = currentUser.permissions[COMPANY_ADMIN] || currentUser.permissions[COMPANY_USER];
  const [error, setError] = React.useState('');

  const handleSetAdmin = () => {
    const newPermissions = {
      ...currentUser.permissions,
      [COMPANY_ADMIN]: true,
      [COMPANY_USER]: false,
    };

    dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
  };

  const handleSetUser = () => {
    const newPermissions = {
      ...currentUser.permissions,
      [COMPANY_ADMIN]: false,
      [COMPANY_USER]: true,
    };
    dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
  };

  return (
    <div>
      <Spacer css={{ marginBlock: 'sm' }}>
        <Text>{`Select user role - Do you want to make ${currentUser.userName} a company admin, or a user?`}</Text>
      </Spacer>
      <Spacer>
        <LabeledControl
          label={<Label>Company Admin - Full access to properties and features. Can invite others.</Label>}
          control={<Checkbox onChange={handleSetAdmin} checked={isAdmin} />}
        />
        <LabeledControl
          label={<Label>User - Customizable access to properties and features. Cannot invite others.</Label>}
          control={<Checkbox onChange={handleSetUser} checked={isUser} />}
        />
      </Spacer>
      <HR />
      {error && <Alert tone="critical">{error}</Alert>}
      <div className="Questions-footer">
        <TextButton className="Role-button" onClick={onCancel} data-eventid={EVENT_IDS.CANCEL_ADDING_NEW_USER}>
          Cancel
        </TextButton>
        <div>
          <TextButton className="Questions-button" onClick={onBack}>
            Back
          </TextButton>
          {isInvitation || (!isAdmin && !isInvitation) ? (
            <Button tone="brand" emphasis="filled" onClick={onNextStep} disabled={!isUserTypeSet}>
              Continue
            </Button>
          ) : (
            <Button
              tone="brand"
              emphasis="filled"
              onClick={() => {
                emitContinueNewUserRoleEvent({ user });
                setError('');
                return (
                  dispatch(UserManagementActions.editableUserSave())
                    // @ts-ignore
                    .then(handleSaveComplete)
                    .catch((error: unknown) => {
                      logError({
                        error,
                        errorType: 'UserManagementActions_editableUserSave',
                        context: 'React component: Role',
                      });
                      setError('An error occurred, please try again.');
                    })
                );
              }}
              data-eventid={EVENT_IDS.CONTINUE_NEW_USER_ROLE}
            >
              Save
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

// @ts-ignore
const mapStateToProps = (state) => ({
  currentUser: state.userManagement.currentUser,
});

// @ts-ignore
export default connect(mapStateToProps)(Role);
